import { createReducer } from '../../../../store.model';

import { ActionType } from './behaviour-selection-dialog.action';
import {
    BehaviourSelectionDialogState,
    defaultState,
} from './behaviour-selection-dialog.state';
import { CheckboxSelected } from './state/checkbox-selected.action';
import { checkboxSelectedReducer } from './state/checkbox-selected.reducer';
import { Load, LoadResult } from './state/load.action';
import { loadReducer, loadResultReducer } from './state/load.reducer';

const { builder, reducer } = createReducer<
    ActionType,
    BehaviourSelectionDialogState
>(defaultState());

builder.add<CheckboxSelected>(
    ActionType.COACHING_DETAIL__BSD__CHECKBOX_SELECTED,
    checkboxSelectedReducer,
);
builder.add<Load>(ActionType.COACHING_DETAIL__BSD__LOAD, loadReducer);
builder.add<LoadResult>(
    ActionType.COACHING_DETAIL__BSD__LOAD_RESULT,
    loadResultReducer,
);

export const behaviourSelectionDialogReducer = reducer;
